const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngagedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2200 2200",
    style: {
      enableBackground: "new 0 0 2200 2200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64ACE2"
    },
    d: "M1313.333,328.636l-86.83-98.545c-1.22-1.384-2.693-2.5-4.315-3.288 c-1.868-0.913-3.936-1.4-6.059-1.4h-116.127H983.871c-2.123,0-4.191,0.487-6.059,1.4c-1.623,0.788-3.095,1.904-4.315,3.288 l-86.83,98.545c-2.326,2.644-3.478,5.948-3.452,9.246c0.026,3.278,1.211,6.55,3.553,9.154l202.957,225.273 c1.976,2.195,4.479,3.599,7.132,4.214c2.064,0.481,4.224,0.481,6.288-0.003c2.65-0.612,5.153-2.019,7.129-4.211l202.957-225.273 c2.342-2.604,3.527-5.876,3.553-9.154C1316.811,334.584,1315.659,331.279,1313.333,328.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9CD6"
    },
    d: "M1096.858,576.522c-2.653-0.615-5.156-2.019-7.132-4.214L886.768,347.035 c-2.343-2.604-3.527-5.876-3.553-9.154h109.326L1096.858,576.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64ACE2"
    },
    d: "M992.541,337.881H883.215c-0.026-3.298,1.125-6.602,3.452-9.246l86.83-98.545 c1.22-1.384,2.693-2.5,4.315-3.288L992.541,337.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72C2F2"
    },
    d: "M1100.002,225.402L992.541,337.881l-14.729-111.079c1.868-0.913,3.936-1.4,6.059-1.4H1100.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64ACE2"
    },
    d: "M1207.459,337.881l-104.313,238.637c-2.064,0.484-4.224,0.484-6.288,0.003L992.541,337.881 H1207.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72C2F2"
    },
    d: "M1222.188,226.802l-14.729,111.079l-107.457-112.479h116.127 C1218.252,225.402,1220.32,225.89,1222.188,226.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64ACE2"
    },
    d: "M1316.784,337.881h-109.325l14.729-111.079c1.623,0.788,3.095,1.904,4.315,3.288l86.83,98.545 C1315.659,331.279,1316.811,334.584,1316.784,337.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9CD6"
    },
    d: "M1316.784,337.881c-0.026,3.278-1.211,6.55-3.553,9.154l-202.957,225.273 c-1.976,2.192-4.479,3.599-7.129,4.211l104.313-238.637H1316.784z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82D1F9"
    },
    points: "1207.459,337.881 992.541,337.881 1100.002,225.402  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC239"
    },
    d: "M1685.937,926.144c-32.027-75.74-77.879-143.739-136.258-202.127 c-58.388-58.388-126.396-104.23-202.127-136.267c-53.749-22.731-109.767-37.786-167.331-45.009 c11.657-11.602,23.324-23.194,34.981-34.787c4.732-4.713,9.565-9.546,12.38-15.602c2.815-6.055,3.25-13.666-0.648-19.083 c-4.315-6-12.676-7.722-19.972-6.63c-7.296,1.102-24.657,8.592-33.25,8.944c-39.111,1.611-28.926-27.139-76.851-27.139 c-47.934,0-37.749,28.75-76.86,27.139c-8.592-0.352-25.944-7.842-33.25-8.944c-7.296-1.093-15.657,0.63-19.972,6.63 c-3.889,5.417-3.463,13.028-0.648,19.083c2.815,6.056,7.648,10.889,12.379,15.602c11.907,11.833,23.815,23.676,35.713,35.509 c-55.61,7.472-109.758,22.287-161.776,44.286c-75.73,32.037-143.739,77.879-202.127,136.267 c-58.379,58.388-104.23,126.387-136.258,202.127c-33.175,78.434-49.999,161.72-49.999,247.543 c0,85.832,16.824,169.118,49.999,247.552c32.027,75.74,77.879,143.739,136.258,202.127 c58.388,58.388,126.396,104.23,202.127,136.267c78.434,33.176,161.72,49.999,247.552,49.999s169.118-16.824,247.552-49.999 c75.73-32.036,143.739-77.879,202.127-136.267c58.379-58.388,104.23-126.387,136.258-202.127 c33.176-78.434,49.999-161.72,49.999-247.552C1735.936,1087.864,1719.112,1004.578,1685.937,926.144z M1591.327,1381.221 c-26.851,63.49-65.305,120.526-114.286,169.507c-48.99,48.99-106.017,87.443-169.507,114.295 c-65.703,27.787-135.526,41.879-207.534,41.879s-141.831-14.092-207.534-41.879c-63.49-26.851-120.517-65.305-169.507-114.295 c-48.981-48.981-87.434-106.017-114.286-169.507c-27.796-65.703-41.879-135.526-41.879-207.534 c0-71.999,14.083-141.822,41.879-207.525c26.852-63.49,65.305-120.526,114.286-169.507 c48.99-48.99,106.017-87.443,169.507-114.295c65.703-27.787,135.526-41.879,207.534-41.879s141.831,14.092,207.534,41.879 c63.49,26.852,120.517,65.305,169.507,114.295c48.981,48.981,87.434,106.017,114.286,169.507 c27.796,65.703,41.879,135.526,41.879,207.525C1633.206,1245.695,1619.123,1315.518,1591.327,1381.221z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagedIcon);
export default __webpack_public_path__ + "static/media/engaged-icon.ed16e44d44fcdca0739a22fe7f6a8482.svg";
export { ForwardRef as ReactComponent };